/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantFeeScheduleHistoryEntry
 */
export interface TenantFeeScheduleHistoryEntry {
    /**
     * 
     * @type {string}
     * @memberof TenantFeeScheduleHistoryEntry
     */
    author_id?: string;
    /**
     * 
     * @type {number}
     * @memberof TenantFeeScheduleHistoryEntry
     */
    date?: number;
    /**
     * Server-computed one-line diff of the change, for billing-dispute forensics.
     * @type {string}
     * @memberof TenantFeeScheduleHistoryEntry
     */
    summary?: string;
}

/**
 * Check if a given object implements the TenantFeeScheduleHistoryEntry interface.
 */
export function instanceOfTenantFeeScheduleHistoryEntry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantFeeScheduleHistoryEntryFromJSON(json: any): TenantFeeScheduleHistoryEntry {
    return TenantFeeScheduleHistoryEntryFromJSONTyped(json, false);
}

export function TenantFeeScheduleHistoryEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantFeeScheduleHistoryEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'author_id': !exists(json, 'author_id') ? undefined : json['author_id'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'summary': !exists(json, 'summary') ? undefined : json['summary'],
    };
}

export function TenantFeeScheduleHistoryEntryToJSON(value?: TenantFeeScheduleHistoryEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'author_id': value.author_id,
        'date': value.date,
        'summary': value.summary,
    };
}

